import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const TimesCircle = createSvgIcon(
  () => (
    <path d="M8 0.75C3.71875 0.75 0.25 4.21875 0.25 8.5C0.25 12.7812 3.71875 16.25 8 16.25C12.2812 16.25 15.75 12.7812 15.75 8.5C15.75 4.21875 12.2812 0.75 8 0.75ZM11.7812 10.5625C11.9375 10.6875 11.9375 10.9375 11.7812 11.0938L10.5625 12.3125C10.4062 12.4688 10.1562 12.4688 10.0312 12.3125L8 10.25L5.9375 12.3125C5.8125 12.4688 5.5625 12.4688 5.40625 12.3125L4.1875 11.0625C4.03125 10.9375 4.03125 10.6875 4.1875 10.5312L6.25 8.5L4.1875 6.46875C4.03125 6.34375 4.03125 6.09375 4.1875 5.9375L5.4375 4.71875C5.5625 4.5625 5.8125 4.5625 5.96875 4.71875L8 6.75L10.0312 4.71875C10.1562 4.5625 10.4062 4.5625 10.5625 4.71875L11.7812 5.9375C11.9375 6.09375 11.9375 6.34375 11.7812 6.46875L9.75 8.5L11.7812 10.5625Z" />
  ),
  '0 0 16 17'
);
